import { memo } from "react";
import { cn } from "@/lib/utils";
import "../shared/LoadingScreen.css";

/**
 * PanelLoader - Panel-level loading state matching LoadingScreen visual style
 * Use for loading states in grids, tabs, and other panel-sized areas
 */
export const PanelLoader = memo(function PanelLoader({
  message = "Loading...",
  className,
}: {
  /** Message to display below the spinner (e.g., "Loading workflows") */
  message?: string;
  className?: string;
}) {
  return (
    <div className={cn("loading-content", className)}>
      {/* 3-ring spinner (same as LoadingScreen) */}
      <div className="loading-spinner">
        <div className="spinner-ring" />
        <div className="spinner-ring" />
        <div className="spinner-ring" />
      </div>

      {/* Loading Message */}
      <div className="loading-message">{message}</div>

      {/* Animated Dots */}
      <div className="loading-dots">
        <span className="dot" />
        <span className="dot" />
        <span className="dot" />
      </div>
    </div>
  );
});

export default PanelLoader;
